import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"


import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';


class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            departamento: null,
        };
    }

    static propTypes = {
        id: PropTypes.func.isRequired,
        buttonClass: PropTypes.string
    }


    ResetForm() {
        this.setState({
            departamento: null,
        });
    }

    setSelects(data) {
        this.setState({
            departamento: data.departamento_id,
        });
    }
    render() {
        return (
            <ParadigmaModal
                getUrl={api.usuarios.personal.detail}
                id={this.props.id}
                successMessage={""}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Persona"}
                buttonIcon={"fa fa-search fa-lg"}
                
                saveButton={false}
                closeButton={true}
                buttonClass={this.props.buttonClass}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.ResetForm()}
            >
                <Row>
                    <Col className="col-6">
                        <Label>Apellido</Label>
                        <Input disabled={true} type="text" name="apellido"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                    <Col className="col-6">
                        <Label>Nombre</Label>
                        <Input disabled={true} type="text" name="nombre"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row>
                    <Col className="col-6">
                        <Label>DNI</Label>
                        <Input disabled={true} type="text" name="dni"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                    <Col className="col-6">
                        <Label>Domicilio</Label>
                        <Input disabled={true} type="text" name="domicilio"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row>
                    <Col className="col-8">
                        <Label>Email</Label>
                        <Input disabled={true} type="text" name="email"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                    <Col className="col-4">
                        <Label>Teléfono</Label>
                        <Input disabled={true} type="text" name="telefono"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>


                <Row>
                    <Col className="col-12">
                        <Label>Grupos</Label>
                        <ParadigmaAsyncSeeker fieldName={""}
                            url={api.usuarios.grupos.select}
                            value={this.state.departamentopadre_id} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>

                <Row>
                    <Col className="col-12">
                        <Label>Subgrupos</Label>
                        <ParadigmaAsyncSeeker fieldName={"departamento_id"}
                            url={api.usuarios.subgrupos.select + (this.state.departamentopadre_id ? "?grupo=" + this.state.departamentopadre_id : "")}
                            value={this.state.departamento} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/Usuarios/Personal/Detail.js